const MINUTE_MS = 60000;

const startOf = (pause) => new Date(pause.startedAt).getTime();

/** A pause ends when the driver resumes, otherwise when its planned duration has elapsed. */
export const pauseEndOf = (pause) => (pause.endedAt
  ? new Date(pause.endedAt).getTime()
  : startOf(pause) + pause.durationMinutes * MINUTE_MS);

/** The pause in progress at `now`, if any. */
export const getActivePause = (pauses, now = Date.now()) => (pauses ?? [])
  .find((p) => startOf(p) <= now && pauseEndOf(p) > now) ?? null;

/** Total milliseconds of pauses falling in [fromMs, toMs]. */
export const pausedMsBetween = (pauses, fromMs, toMs) => (pauses ?? []).reduce((total, p) => {
  const overlap = Math.min(pauseEndOf(p), toMs) - Math.max(startOf(p), fromMs);
  return total + Math.max(0, overlap);
}, 0);

/** Total minutes already spent in pause (the running one counts up to `now`). */
export const totalPausedMinutes = (pauses, now = Date.now()) => Math.round(
  pausedMsBetween(pauses, 0, now) / MINUTE_MS,
);

/** Milliseconds of declared pauses still to come after `fromMs` (a running pause's remainder). */
export const remainingPauseMs = (pauses, fromMs, now = Date.now()) => (pauses ?? [])
  .filter((p) => startOf(p) <= now)
  .reduce((total, p) => total + Math.max(0, pauseEndOf(p) - Math.max(startOf(p), fromMs)), 0);
